<!-- MIT License

Copyright (c) 2025 Brad Schick

Permission is hereby granted, free of charge, to any person obtaining a copy
of this software and associated documentation files (the "Software"), to deal
in the Software without restriction, including without limitation the rights
to use, copy, modify, merge, publish, distribute, sublicense, and/or sell
copies of the Software, and to permit persons to whom the Software is
furnished to do so, subject to the following conditions:

The above copyright notice and this permission notice shall be included in all
copies or substantial portions of the Software.

THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR
IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY,
FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE
AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER
LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM,
OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN THE
SOFTWARE. -->
<span class="recovery">
  <h1 mat-dialog-title class="header">Recovery Actions</h1>

  <div mat-dialog-content class="dialog-content">
    <ol class="steps" type="1">
      <li>
        First, ensure your internet connection is working. If you have a good connection
        and have previously used Quick Crypt, select the passkey you used when
        you first signed in. You may have created a passkey with a
        physical key, a mobile device, or a password manager like Bitwarden or 1Password.
      </li>

      <li>If you lost or damaged your passkeys, take one of these actions:

        <ul class="inner-steps">
          <li><a [routerLink]="'/recovery3'" (click)="onClickRecovery3($event)">Restore access to your account</a>
            using the recovery words provided when you created your account. Just
            follow the link above and enter your recovery word pattern.</li>
          <li>If you created an account before Quick Crypt switched to recovery words,
            locate the <b>recovery link</b> that was provided
            when you created your account. Then paste that link into your browser's
            address bar and press Enter.</li>
        </ul>
      </li>
      <li>
        If you lost both your Quick Crypt passkeys and recovery information, you cannot
        access your existing user identity to decrypt or encrypt data. To continue using
        Quick Crypt, you may <a [routerLink]="'/newuser'" (click)="onClickNewUser($event)">
        create a new account</a>.
        If you find your original recovery information or passkey, you can use either to
        regain access to your account and decrypt data.
      </li>
      <li>
        If you found a problem with Quick Crypt, please
        <a href="https://github.com/bschick/qcrypt/issues/new/choose" target="_blank">
        report the issue</a>.
      </li>
    </ol>

    <!--last so it doesn't get focus-->
    <button class="close-button3" matSuffix mat-icon-button mat-dialog-close aria-label="close">
      <mat-icon>close</mat-icon>
    </button>
  </div>
</span>